export default "__VITE_ASSET__CLWcRxS0__"